<div class="empty-state">
  @if (icon()) {
    <mat-icon class="empty-state-icon">{{ icon() }}</mat-icon>
  } @else if (image()) {
    <img [src]="image()" alt="No Results Found" class="empty-state-image" />
  }
  <div class="empty-state-title">{{ title() }}</div>
  <div class="empty-state-subtitle">{{ getSubtitle() }}</div>
</div>
